import SplideLib from "@splidejs/splide";
import SplideNacFade from "./splideNacFade";


export default function Splide( opts = {} ) {
  return {
    config: {
      options: {},
      ...opts,
    },
    splide: null,

    get index() {
      return this.splide ? this.splide.index : 0
    },

    init() {
      this.splideInit();
    },

    splideInit(fade = true) {
      let el = this.$root;

      // if there's a ref of 'slider' then use that instead of root el
      if ( this.$refs.slider ) {
        el = this.$refs.slider;
      }

      // initialise splide
      this.splide = new SplideLib( el, this.config.options );

      // mount
      if (fade) {
        this.splide.on( 'pagination:mounted', function ( data ) {
  
          // `items` contains all dot items
          data.items.forEach( function ( item ) {
              item.button.innerHTML = '<div></div>';
          });
        });
        console.log('cust');

        this.splide.mount({}, SplideNacFade );
      } else {

        this.splide.on('mounted', function() {
          let pages = document.querySelectorAll('.splide__pagination li');
          var count = pages.length;
          var w = (100/count) +'%';
          pages.forEach(function(p) {
            p.style.width = w;
          });
        });
        this.splide.mount({} );
      }
      
    },

  };
}
